(function () {
  'use strict';

  function initCarousel(carousel) {
    var slides = Array.from(carousel.querySelectorAll('.wtl-carousel__slide'));
    if (!slides.length) return;

    var current = 0;
    var autoplay = carousel.dataset.autoplay === 'true';
    var timer = null;
    var dotsContainer = carousel.querySelector('.wtl-carousel__dots');

    // Build dots
    if (dotsContainer) {
      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.className = 'wtl-carousel__dot';
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        dot.addEventListener('click', function () { goTo(i); resetTimer(); });
        dotsContainer.appendChild(dot);
      });
    }

    function updateDots() {
      if (!dotsContainer) return;
      dotsContainer.querySelectorAll('.wtl-carousel__dot').forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
      });
    }

    function goTo(n) {
      slides[current].classList.remove('is-active');
      current = (n + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      updateDots();
    }

    // Activate first slide
    slides[0].classList.add('is-active');
    updateDots();

    // Prev / Next
    var prevBtn = carousel.querySelector('.wtl-carousel__btn--prev');
    var nextBtn = carousel.querySelector('.wtl-carousel__btn--next');
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); resetTimer(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); resetTimer(); });

    // Touch / swipe
    var touchStartX = 0;
    carousel.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    carousel.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        diff > 0 ? goTo(current + 1) : goTo(current - 1);
        resetTimer();
      }
    }, { passive: true });

    // Autoplay
    function startTimer() {
      if (!autoplay || slides.length <= 1) return;
      timer = setInterval(function () { goTo(current + 1); }, 4000);
    }

    function resetTimer() {
      clearInterval(timer);
      startTimer();
    }

    startTimer();
  }

  function initAll() {
    document.querySelectorAll('.wtl-carousel:not([data-carousel-init])').forEach(function (el) {
      el.setAttribute('data-carousel-init', '1');
      initCarousel(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function () { initAll(); });

})();
